import { render, staticRenderFns } from "./BrandPriceAdjustmentList.vue?vue&type=template&id=d49360a4&scoped=true&"
import script from "./BrandPriceAdjustmentList.vue?vue&type=script&lang=js&"
export * from "./BrandPriceAdjustmentList.vue?vue&type=script&lang=js&"
import style0 from "./BrandPriceAdjustmentList.vue?vue&type=style&index=0&id=d49360a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49360a4",
  null
  
)

export default component.exports